import { WifAppProvider as ut } from "./context.js";
import { FaqAccordion as mt } from "./FaqAccordion.js";
import { ItemList as gt } from "./ItemList.js";
import { u as Q } from "./useClickOutside-726e7c36.mjs";
import { a as yt } from "./useClickOutside-726e7c36.mjs";
import { B as K, a as V } from "./Block-9b78bd10.mjs";
import { B as Et } from "./BottomSheet-3ea85daf.mjs";
import { B as ne } from "./Button-c598cb52.mjs";
import { C as It } from "./CallToAction-d24a74ed.mjs";
import e, { useRef as T, useState as M, useEffect as z, useCallback as f, useSyncExternalStore as ae, forwardRef as O, useMemo as ce } from "react";
import { c as l, t as b } from "./app-a75c1d35.mjs";
import { I as N, W as S } from "./Icon-3122c134.mjs";
import { C as Bt } from "./Chips-2709174d.mjs";
import { D as ie } from "./Dropdown-cd8b285a.mjs";
import { u as At } from "./Dropdown-cd8b285a.mjs";
import { V as se } from "./VideoIcon-87fb4a33.mjs";
import { I as Nt, a as St } from "./Image-d6406817.mjs";
import { L as Ut } from "./Link-479ac100.mjs";
import { L as Pt, u as wt, a as Tt } from "./Logo-f02d52de.mjs";
import { a as X, m as le } from "./index-615eb227.mjs";
import { N as Ft, u as Ht, b as Gt, d as $t, c as Rt } from "./index-615eb227.mjs";
import { M as Mt, a as zt, u as Ot } from "./useModal-4683a76a.mjs";
import { V as Kt, a as Vt } from "./Video-232035c2.mjs";
import { u as Zt } from "./LinkContext-0c83848a.mjs";
import { u as Jt } from "./ImageContext-57256dc1.mjs";
import "./index-099c513a.mjs";
import "react-dom";
import "./ArticleSection.js";
import "./Image.module-8b345b58.mjs";
function ee(r = {}) {
  const { disableFocusEvent: t = !1, disableHoverEvent: o = !1 } = r, n = T(null), [a, c] = M(!1);
  return z(() => {
    const i = n.current;
    if (!i)
      return;
    const s = () => c(!0), u = () => c(!1);
    return o || (i.addEventListener("mouseenter", s), i.addEventListener("mouseleave", u)), t || (i.addEventListener("focus", s), i.addEventListener("blur", u)), () => {
      u(), o || (i.removeEventListener("mouseenter", s), i.removeEventListener("mouseleave", u)), t || (i.removeEventListener("focus", s), i.removeEventListener("blur", u));
    };
  }, [t, o]), { ref: n, isHovering: a, setIsHovering: c };
}
function Qr(r, t, o, n) {
  const a = X(t);
  z(() => j(n || window, r, a, o), [r, a, n, o]);
}
function j(r, t, o, n) {
  return n ? () => {
  } : (r.addEventListener(t, o), () => r.removeEventListener(t, o));
}
function Xr(r, t, o = {}) {
  const n = X(r);
  z(
    () => de(n, t, {
      disabled: o.disabled,
      maxDuration: o.maxDuration,
      executeImmediately: o.executeImmediately
    }),
    [
      n,
      t,
      o.disabled,
      o.maxDuration,
      o.executeImmediately
    ]
  );
}
function de(r, t, o = {}) {
  const { disabled: n, maxDuration: a, executeImmediately: c } = o;
  if (n || t <= 0)
    return () => {
    };
  let i = 0;
  c && r(i);
  const s = window.setInterval(() => {
    i += t, a && i >= a && window.clearInterval(s), r(i) && window.clearInterval(s);
  }, t);
  return () => window.clearInterval(s);
}
const ue = "checkbox", pe = "no-padding", me = "checkbox__icon", be = "checkbox__icon--dark-bg", ge = "checkbox__icon--error", _e = "checkbox__input", U = {
  checkbox: ue,
  noPadding: pe,
  checkboxIcon: me,
  checkboxIconDarkBg: be,
  checkboxIconError: ge,
  checkboxInput: _e
};
function et({
  label: r,
  name: t,
  checked: o,
  onChange: n,
  disabled: a,
  error: c,
  onDarkBackground: i,
  required: s,
  noPadding: u
}) {
  const { isHovering: d, ref: g } = ee(), p = Q();
  return /* @__PURE__ */ e.createElement(
    "label",
    {
      className: l(U.checkbox, u && U.noPadding),
      ref: g,
      "data-hover": d,
      "aria-disabled": a
    },
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: l(
          U.checkboxIcon,
          c && U.checkboxIconError,
          (i === !0 || p) && U.checkboxIconDarkBg
        ),
        "aria-checked": o
      },
      o && /* @__PURE__ */ e.createElement(N, { icon: S.CHECK, size: 16 }),
      /* @__PURE__ */ e.createElement(
        "input",
        {
          className: U.checkboxInput,
          type: "checkbox",
          checked: o,
          onChange: (y) => n?.(y.target.checked),
          name: t,
          required: s
        }
      )
    ),
    r
  );
}
const ye = "curtain", xe = "curtain--show", Z = {
  curtain: ye,
  curtainShow: xe
};
function rt({ show: r = !1 }) {
  return /* @__PURE__ */ e.createElement("div", { className: l(Z.curtain, r && Z.curtainShow) });
}
const Ee = "error-handler", he = "desktop", Ie = "error-handler--heading", fe = "error-handler--description", Be = "error-handler--icon", F = {
  errorHandler: Ee,
  desktop: he,
  errorHandlerHeading: Ie,
  errorHandlerDescription: fe,
  errorHandlerIcon: Be
};
function tt({
  title: r,
  description: t,
  videoSrc: o,
  fallbackSrc: n
}) {
  return /* @__PURE__ */ e.createElement(K, { topPadding: V.NONE, bottomPadding: V.NONE }, /* @__PURE__ */ e.createElement(K.Content, { flex: !0, className: l(F.errorHandler) }, /* @__PURE__ */ e.createElement("div", { className: l(F.errorHandlerIcon) }, /* @__PURE__ */ e.createElement(se, { src: o, fallbackImgSrc: n })), /* @__PURE__ */ e.createElement(
    "p",
    {
      className: l(
        F.errorHandlerHeading,
        b.headingSection
      )
    },
    r
  ), /* @__PURE__ */ e.createElement(
    "p",
    {
      className: l(
        F.errorHandlerDescription,
        b.textsBodyText
      )
    },
    t
  )));
}
const Ce = "media-upload", Ae = "media-upload__help-text", ve = "media-upload__area", Ne = "desktop", Se = "media-upload__area__content", ke = "media-upload__area__icon", Ue = "media-upload__area__texts", Le = "media-upload__area__texts__subheading", Pe = "media-upload__area__button", we = "media-upload__area__input", Te = "media-upload__banner", De = "media-upload__banner--error", Fe = "media-upload__banner__file-icon", He = "media-upload__banner__file-icon--error", Ge = "media-upload__banner__content", $e = "media-upload__banner__content__fileSize", Re = "media-upload__banner__content__fileSize--error", We = "media-upload__banner__clear-button", Me = "media-upload__errorMessage", m = {
  mediaUpload: Ce,
  mediaUploadHelpText: Ae,
  mediaUploadArea: ve,
  desktop: Ne,
  mediaUploadAreaContent: Se,
  mediaUploadAreaIcon: ke,
  mediaUploadAreaTexts: Ue,
  mediaUploadAreaTextsSubheading: Le,
  mediaUploadAreaButton: Pe,
  mediaUploadAreaInput: we,
  mediaUploadBanner: Te,
  mediaUploadBannerError: De,
  mediaUploadBannerFileIcon: Fe,
  mediaUploadBannerFileIconError: He,
  mediaUploadBannerContent: Ge,
  mediaUploadBannerContentFileSize: $e,
  mediaUploadBannerContentFileSizeError: Re,
  mediaUploadBannerClearButton: We,
  mediaUploadErrorMessage: Me
}, G = 1024, w = G * G, Y = w * w, ze = {
  IMAGES: ["image/jpeg", "image/webp", "image/png"],
  VIDEOS: ["video/mp4", "video/mpeg"],
  AUDIOS: ["audio/mpeg", "audio/wav", "audio/ogg", "audio/webm", "audio/mp3"]
};
function ot({
  label: r,
  caption: t,
  onChange: o,
  disabled: n,
  required: a,
  supportedMimeTypes: c = ze.IMAGES,
  maxFileSize: i = w,
  fileIcon: s = S.SIGHTSEEING,
  name: u,
  value: d,
  errorMessage: g,
  i18n: p = {}
}) {
  const {
    maximumSizeLabel: y = "Maximum size",
    optionalLabel: h = "Optional",
    unsupportedFileTypeError: x = "File type not supported",
    browseFilesLabel: A = "Browse files",
    removeFileLabel: B = "Remove file"
  } = p, E = T(null), k = !!(d && c.includes(d.type)), R = (d?.size || 0) > i, I = c.map((oe) => oe.split("/")[1]).join(", "), v = f(() => {
    o(void 0), E.current?.value && (E.current.value = "");
  }, [o]), D = `media-upload-${u || "input"}`, q = `${D}-label`, W = g ? `${D}-error` : void 0;
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: m.mediaUpload,
      role: "group",
      "aria-labelledby": q,
      "aria-describedby": W
    },
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: l(m.mediaUploadHelpText, b.textsCaption)
      },
      /* @__PURE__ */ e.createElement("label", { id: q, htmlFor: D }, r, " ", a ? null : h ? `(${h})` : null),
      /* @__PURE__ */ e.createElement("span", null, y, " ", J(i))
    ),
    /* @__PURE__ */ e.createElement(
      Oe,
      {
        disabled: n,
        heading: t,
        subheading: I,
        onChange: o,
        supportedMimeTypes: c,
        buttonLabel: A,
        name: u,
        inputId: D,
        required: a,
        ariaInvalid: !!g,
        ariaDescribedBy: W,
        forwardedInputRef: E
      }
    ),
    d ? /* @__PURE__ */ e.createElement(
      qe,
      {
        disabled: n,
        fileName: d.name,
        fileIcon: s,
        resetFile: v,
        removeFileLabel: B,
        errorMessage: R ? J(d.size) : k ? void 0 : x
      }
    ) : null,
    !!g && /* @__PURE__ */ e.createElement(
      "div",
      {
        id: W,
        role: "alert",
        className: b.textsCaption && m.mediaUploadErrorMessage
      },
      g
    )
  );
}
function Oe({
  heading: r = "Upload",
  subheading: t,
  onChange: o,
  supportedMimeTypes: n,
  buttonLabel: a,
  name: c,
  disabled: i,
  forwardedInputRef: s,
  inputId: u,
  required: d,
  ariaInvalid: g,
  ariaDescribedBy: p
}) {
  const y = T(null), [h, x] = M(!1), A = f(
    (I) => {
      i || (I.preventDefault(), I.stopPropagation(), x(!0));
    },
    [i]
  ), B = f(() => x(!1), []), E = f(() => y.current?.click(), []), k = f(
    (I) => {
      if (I.preventDefault(), i)
        return;
      x(!1);
      const v = I.dataTransfer.files?.[0];
      v && o(v);
    },
    [i, o]
  ), R = f(
    (I) => {
      const v = I.target.files?.[0];
      v && o(v);
    },
    [o]
  );
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: m.mediaUploadArea,
      onClick: E,
      onDragOver: A,
      onDragLeave: B,
      onDrop: k,
      "data-dragover": h
    },
    /* @__PURE__ */ e.createElement("div", { className: m.mediaUploadAreaContent }, /* @__PURE__ */ e.createElement("div", { className: m.mediaUploadAreaIcon, role: "none" }, /* @__PURE__ */ e.createElement(N, { icon: S.SHARE, size: 24 })), /* @__PURE__ */ e.createElement("div", { className: m.mediaUploadAreaTexts }, /* @__PURE__ */ e.createElement("span", { className: b.textsLeadTextBold }, r), t && /* @__PURE__ */ e.createElement(
      "span",
      {
        className: l(
          m.mediaUploadAreaTextsSubheading,
          b.textsLeadText
        )
      },
      t
    )), /* @__PURE__ */ e.createElement(
      ne.Primary,
      {
        asDiv: !0,
        text: a,
        className: m.mediaUploadAreaButton
      }
    )),
    /* @__PURE__ */ e.createElement(
      "input",
      {
        type: "file",
        id: u,
        name: c,
        disabled: i,
        required: d,
        "aria-required": d || void 0,
        "aria-invalid": g || void 0,
        "aria-describedby": p,
        ref: le(y, s),
        onChange: R,
        className: m.mediaUploadAreaInput,
        accept: n.join(", ")
      }
    )
  );
}
function qe({
  fileName: r,
  errorMessage: t,
  resetFile: o,
  disabled: n,
  fileIcon: a,
  removeFileLabel: c = "Remove file"
}) {
  return /* @__PURE__ */ e.createElement(
    "output",
    {
      className: l(
        m.mediaUploadBanner,
        t && m.mediaUploadBannerError
      )
    },
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: l(
          m.mediaUploadBannerFileIcon,
          t && m.mediaUploadBannerFileIconError
        ),
        role: "none"
      },
      /* @__PURE__ */ e.createElement(N, { icon: a, size: 20 })
    ),
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: l(
          m.mediaUploadBannerContent,
          b.textsLeadText
        )
      },
      /* @__PURE__ */ e.createElement("span", null, r),
      /* @__PURE__ */ e.createElement(
        "span",
        {
          className: l(
            m.mediaUploadBannerContentFileSize,
            t && m.mediaUploadBannerContentFileSizeError
          )
        },
        typeof t == "string" ? t : null
      )
    ),
    !n && /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        onClick: o,
        "aria-label": c,
        title: c,
        className: m.mediaUploadBannerClearButton
      },
      /* @__PURE__ */ e.createElement(N, { icon: S.CLOSE, size: 20 })
    )
  );
}
function J(r) {
  return r >= Y ? `${(r / Y).toFixed(2)} GB` : r >= w ? `${(r / w).toFixed(2)} MB` : r >= G ? `${(r / G).toFixed(2)} KB` : `${r} Bytes`;
}
const Ke = "phone-number-input", Ve = "phone-number-input__label", je = "phone-number-input__label--error", Ze = "phone-number-input__errorMessage", Ye = "phone-number-input__container", Je = "phone-number-input__container--large", Qe = "phone-number-input__container--error", Xe = "phone-number-input__dropdown", er = "phone-number-input__dropdown__button", rr = "phone-number-input__dropdown__list", tr = "phone-number-input__dropdown__flag", or = "phone-number-input__divider", nr = "phone-number-input__country-code", ar = "phone-number-input__country-code--error", cr = "phone-number-input__input-field", _ = {
  phoneNumberInput: Ke,
  phoneNumberInputLabel: Ve,
  phoneNumberInputLabelError: je,
  phoneNumberInputErrorMessage: Ze,
  phoneNumberInputContainer: Ye,
  phoneNumberInputContainerLarge: Je,
  phoneNumberInputContainerError: Qe,
  phoneNumberInputDropdown: Xe,
  phoneNumberInputDropdownButton: er,
  phoneNumberInputDropdownList: rr,
  phoneNumberInputDropdownFlag: tr,
  phoneNumberInputDivider: or,
  phoneNumberInputCountryCode: nr,
  phoneNumberInputCountryCodeError: ar,
  phoneNumberInputInputField: cr
};
function ir(r, t) {
  const o = 10 ** Math.round(t);
  return Math.round(r * o) / o;
}
function sr(r) {
  const t = f(
    () => dr(r),
    [r]
  );
  return ae(lr, t, () => 0);
}
function lr(r) {
  return r(), window.addEventListener("resize", r, { passive: !0 }), () => window.removeEventListener("resize", r);
}
function dr(r, t = 0) {
  return ir(
    r.current?.getBoundingClientRect().width || t,
    0
  );
}
const $ = [
  {
    flagUrl: "/flags/fi.svg",
    name: "Soumi",
    code: "+358"
  },
  {
    flagUrl: "/flags/sv.svg",
    name: "Sverige",
    code: "+46"
  }
], ur = $.map(re), nt = O(function({
  errorMessage: t,
  dataTestid: o,
  label: n,
  onValueChange: a,
  onChange: c,
  height: i = "normal",
  ...s
}, u) {
  const d = T(null), g = sr(d), [p, y] = M($[0]), h = l(
    b.textsCaption,
    _.phoneNumberInputLabel,
    t && _.phoneNumberInputLabelError
  ), x = f(
    (E) => {
      const k = E.target.value;
      c?.(E), a?.(k ? p.code + k : "");
    },
    [p.code, a, c]
  ), A = f((E) => {
    y(te(E[0]));
  }, []), B = ce(
    () => [re(p)],
    [p]
  );
  return /* @__PURE__ */ e.createElement("div", { className: _.phoneNumberInput }, n && /* @__PURE__ */ e.createElement("label", { className: h }, n, s.required ? " *" : null), /* @__PURE__ */ e.createElement(
    "div",
    {
      ref: d,
      "aria-disabled": s.disabled,
      "data-testid": o,
      className: l(
        _.phoneNumberInputContainer,
        b.textsLeadText,
        t && _.phoneNumberInputContainerError,
        i === "large" && _.phoneNumberInputContainerLarge
      ),
      style: {
        "--phone-input-container-width": g.toFixed(0) + "px"
      }
    },
    /* @__PURE__ */ e.createElement(
      ie,
      {
        name: `${s.name}-cc`,
        items: ur,
        isMulti: !1,
        label: pr,
        selectedItems: B,
        onSelectedItemsChange: A,
        className: _.phoneNumberInputDropdown,
        buttonClassName: _.phoneNumberInputDropdownButton,
        listClassName: _.phoneNumberInputDropdownList,
        disabled: s.disabled
      }
    ),
    /* @__PURE__ */ e.createElement("div", { className: _.phoneNumberInputDivider, role: "none" }),
    /* @__PURE__ */ e.createElement(
      "span",
      {
        className: l(
          _.phoneNumberInputCountryCode,
          t && _.phoneNumberInputCountryCodeError
        )
      },
      p.code
    ),
    /* @__PURE__ */ e.createElement(
      "input",
      {
        ...s,
        type: "tel",
        className: _.phoneNumberInputInputField,
        onChange: x,
        ref: u,
        inputMode: "numeric"
      }
    )
  ), t && /* @__PURE__ */ e.createElement(
    "span",
    {
      className: l(
        b.textsCaption,
        _.phoneNumberInputErrorMessage
      )
    },
    t
  ));
});
function pr({ selectedItems: r }) {
  const t = te(r[0]);
  return /* @__PURE__ */ e.createElement(
    "img",
    {
      src: t.flagUrl,
      alt: "",
      "aria-hidden": "true",
      className: _.phoneNumberInputDropdownFlag
    }
  );
}
function mr({ flagUrl: r, name: t, code: o }) {
  return /* @__PURE__ */ e.createElement("div", { style: { display: "flex", alignItems: "center", gap: "1rem" } }, /* @__PURE__ */ e.createElement(
    "img",
    {
      src: r,
      alt: "",
      "aria-hidden": "true",
      className: _.phoneNumberInputDropdownFlag
    }
  ), " ", t, " ", /* @__PURE__ */ e.createElement("span", { className: _.phoneNumberInputCountryCode }, o));
}
function re(r) {
  return {
    label: /* @__PURE__ */ e.createElement(mr, { ...r }),
    value: r.code
  };
}
function te(r) {
  return $.find((t) => t.code === r?.value) || $[0];
}
const br = "progressBar", gr = "progressBar__container", _r = "progressBar__wrapper", yr = "progressBar__fill", H = {
  progressBar: br,
  progressBarContainer: gr,
  progressBarWrapper: _r,
  progressBarFill: yr
};
function at({
  totalSteps: r,
  currentStep: t,
  stepLabel: o = "Step",
  ofLabel: n = "of"
}) {
  const a = Math.min(r, Math.max(0, t)), c = Math.min(
    100,
    Math.max(0, Math.round(a / r * 100))
  );
  return /* @__PURE__ */ e.createElement("div", { className: H.progressBar }, /* @__PURE__ */ e.createElement("div", { className: H.progressBarContainer }, /* @__PURE__ */ e.createElement("p", null, o, " ", a, " ", /* @__PURE__ */ e.createElement("span", null, n, " ", r))), /* @__PURE__ */ e.createElement("div", { className: H.progressBarWrapper }, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: H.progressBarFill,
      style: {
        width: `${c}%`
      }
    }
  )));
}
const xr = "radio", Er = "radio__icon", hr = "radio__icon--dark-bg", Ir = "radio__icon--error", fr = "radio__input", P = {
  radio: xr,
  radioIcon: Er,
  radioIconDarkBg: hr,
  radioIconError: Ir,
  radioInput: fr
};
function ct({
  label: r,
  name: t,
  checked: o,
  onChange: n,
  disabled: a,
  error: c,
  onDarkBackground: i,
  required: s
}) {
  const { isHovering: u, ref: d } = ee(), g = Q();
  return /* @__PURE__ */ e.createElement(
    "label",
    {
      className: l(P.radio),
      ref: d,
      "data-hover": u,
      "aria-disabled": a
    },
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: l(
          P.radioIcon,
          c && P.radioIconError,
          (i === !0 || g) && P.radioIconDarkBg
        ),
        "aria-checked": o
      },
      /* @__PURE__ */ e.createElement(
        "input",
        {
          className: P.radioInput,
          type: "radio",
          checked: o,
          onChange: (p) => n?.(p.target.checked),
          name: t,
          required: s
        }
      )
    ),
    r
  );
}
const Br = "textarea", Cr = "textarea__label", Ar = "textarea__input", vr = "textarea__input--error", Nr = "textarea__footer", Sr = "textarea__errorMessage", L = {
  textarea: Br,
  textareaLabel: Cr,
  textareaInput: Ar,
  textareaInputError: vr,
  textareaFooter: Nr,
  textareaErrorMessage: Sr
};
function kr({
  label: r,
  errorMessage: t,
  onChange: o,
  onValueChange: n,
  maxLength: a = 500,
  ...c
}, i) {
  const s = T(null), u = l(
    b.textsCaption,
    t && L.textareaLabelError
  ), d = (p) => {
    o?.(p);
    const y = p.target.value || "";
    n?.(y), s.current && (s.current.innerText = y.length.toString());
  }, g = t && c.id ? `${c.id}-error` : void 0;
  return /* @__PURE__ */ e.createElement("div", { className: L.textarea }, r && /* @__PURE__ */ e.createElement("label", { htmlFor: c.id, className: u }, c.required ? `${r} *` : r), /* @__PURE__ */ e.createElement(
    "textarea",
    {
      ref: i,
      maxLength: a,
      rows: a / 100,
      ...c,
      "aria-required": c.required || void 0,
      "aria-invalid": t ? !0 : void 0,
      "aria-describedby": g,
      onChange: d,
      className: l(
        L.textareaInput,
        b.textsLeadText,
        t && L.textareaInputError
      )
    }
  ), /* @__PURE__ */ e.createElement("div", { className: L.textareaFooter }, /* @__PURE__ */ e.createElement(
    "div",
    {
      id: g,
      role: t ? "alert" : void 0,
      className: b.textsCaption && L.textareaErrorMessage
    },
    t
  ), /* @__PURE__ */ e.createElement("div", { className: b.textsCaption }, /* @__PURE__ */ e.createElement("span", { ref: s }, c.value?.length || 0), "/", a)));
}
const it = O(kr), Ur = "text-input", Lr = "text-input__container", Pr = "text-input__container__input_field", wr = "text-input__container__input_field--error", Tr = "text-input__container__icon_button", Dr = "text-input__container__icon_button--error", Fr = "text-input__container--error", Hr = "text-input__errorMessage", C = {
  textInput: Ur,
  textInputContainer: Lr,
  textInputContainerInputField: Pr,
  textInputContainerInputFieldError: wr,
  textInputContainerIconButton: Tr,
  textInputContainerIconButtonError: Dr,
  textInputContainerError: Fr,
  textInputErrorMessage: Hr
};
function Gr({
  label: r,
  dataTestid: t,
  buttonTargetId: o,
  iconState: n,
  errorMessage: a,
  onValueChange: c,
  onIconClick: i,
  buttonContent: s,
  helpText: u,
  ...d
}, g) {
  const p = l(
    b.textsCaption
    // errorMessage && styles.textInputLabelError
  ), y = `input-${d.name}`, h = u ? `${y}-help` : void 0, x = a ? `${y}-error` : void 0, A = l(h, x) || void 0;
  return /* @__PURE__ */ e.createElement("div", { className: C.textInput }, r && /* @__PURE__ */ e.createElement("label", { className: p, htmlFor: y }, d.required ? `${r} *` : r), /* @__PURE__ */ e.createElement(
    "div",
    {
      className: l(
        b.textsLeadText,
        C.textInputContainer,
        a && C.textInputContainerError
      ),
      "data-testid": t
    },
    /* @__PURE__ */ e.createElement(
      "input",
      {
        ...d,
        id: y,
        "aria-required": d.required || void 0,
        "aria-invalid": a ? !0 : void 0,
        "aria-describedby": A,
        className: l(
          C.textInputContainerInputField,
          a && C.textInputContainerInputFieldError
        ),
        onChange: (B) => {
          c?.(B.target.value), d.onChange?.(B);
        },
        ref: g
      }
    ),
    n && /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: l(
          C.textInputContainerIconButton,
          a && C.textInputContainerIconButtonError
        ),
        onClick: i,
        "data-testid": o,
        title: l(
          n === "SEARCH" && "Search",
          n === "CLEAR" && "Clear",
          n === "CHECK" && "Check"
        )
      },
      s,
      n === "SEARCH" && /* @__PURE__ */ e.createElement(N, { icon: S.SEARCH, size: 20 }),
      n === "CLEAR" && /* @__PURE__ */ e.createElement(N, { icon: S.CLOSE, size: 20 }),
      n === "CHECK" && /* @__PURE__ */ e.createElement(N, { icon: S.CHECK, size: 20 })
    )
  ), u && /* @__PURE__ */ e.createElement("div", { id: h, className: b.textsCaption }, u), a && /* @__PURE__ */ e.createElement(
    "div",
    {
      id: x,
      role: "alert",
      className: b.textsCaption && C.textInputErrorMessage
    },
    a
  ));
}
const st = O(Gr);
export {
  K as Block,
  V as BlockPadding,
  Et as BottomSheet,
  ne as Button,
  It as CallToAction,
  et as Checkbox,
  Bt as Chips,
  rt as Curtain,
  ie as Dropdown,
  tt as ErrorHandler,
  mt as FaqAccordion,
  N as Icon,
  Nt as Image,
  St as ImageStyles,
  gt as ItemList,
  Ut as Link,
  Pt as Logo,
  ze as MIME_TYPE_MAP,
  ot as MediaUpload,
  Mt as Modal,
  Ft as NOOP,
  nt as PhoneNumberInput,
  at as ProgressBar,
  ct as Radio,
  st as TextInput,
  it as Textarea,
  Kt as Video,
  se as VideoIcon,
  Vt as VideoStyles,
  ut as WifAppProvider,
  S as WifIcon,
  de as createIntervalWithCleanup,
  j as eventListenerWithCleanup,
  zt as useBlockNativeScroll,
  At as useDropdownRef,
  ee as useElementHover,
  Ht as useElementIntersection,
  Q as useEmployerSite,
  Qr as useEventListener,
  wt as useFocusTrap,
  Jt as useImageContext,
  Xr as useInterval,
  yt as useKeyDown,
  Zt as useLinkContext,
  Ot as useModal,
  X as useStableCallback,
  Gt as useStableLayoutEffect,
  $t as useStableMemo,
  Rt as useStableRef,
  Tt as useVerifyChildren
};
//# sourceMappingURL=main.js.map
